<div class="d-flex" id="wrapper">

  <admin-sidebar id="admin-sidebar"></admin-sidebar>

  <div id="page-content-wrapper">

    <admin-navigation></admin-navigation>

    <div class="container-fluid">
      <div class="mt-5 mt-md-5 mb-3 mb-md-3">
        <h3 class="font-weight-bold page-title">Users</h3>
      </div>
      <div class="row mb-4 mb-md-4">

        <div class="form-group col-md-2">
          <div class="input-group">
            <input
              class="form-control"
              placeholder="Signed Up Date from"
              name="fromDate"
              ngbDatepicker
              (click)="fd.toggle()"
              (dateSelect)="onDateFromSelection($event)"
              #fd="ngbDatepicker"
              id="dateInputFrom"
              readonly
              [(ngModel)]="dpFromDate"
            >
            <div class="input-group-append clear-date">
              <span class="input-group-text" (click)="clearDateFrom()"><i class="fa fa-times"></i> </span>
            </div>
          </div>
        </div>

        <div class="form-group col-md-2">
          <div class="input-group">
            <input
              class="form-control"
              placeholder="Signed Up Date to"
              name="toDate"
              ngbDatepicker
              (click)="td.toggle()"
              (dateSelect)="onDateToSelection($event)"
              #td="ngbDatepicker"
              id="dateInputTo"
              [(ngModel)]="dpToDate"
              readonly
            >
            <div class="input-group-append clear-date">
              <span class="input-group-text" (click)="clearDateTo()"><i class="fa fa-times"></i> </span>
            </div>
          </div>
        </div>

        <div class="col-md-2 mb-3">
          <select id="status" class="form-control" (change)="searchStatus()" [(ngModel)]="searchStatusVal">
            <option value="">All</option>
            <option value="0">Active</option>
            <option value="1">Inactive</option>
          </select>
        </div>

        <div class="col-md-3 mb-3">
          <select id="roles" class="form-control" (change)="searchStatus()" [(ngModel)]="searchRoleVal">
            <option value="">All Roles</option>
            <option value="individual">Individual (paid and not paid users)</option>
            <option value="subscribe">Subscribed (paid users)</option>
            <option value="employee">Employee</option>
            <option value="manager">Manager</option>
            <option value="admin">Admin</option>
          </select>
        </div>

        <div class="col-md-3">
          <input type="text" class="form-control" placeholder="Search by name, email, organisation" #searchUserInput>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h5>Total: {{ usersTotal }}</h5>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 table-responsive">
          <table class="table table-borderless">
            <thead>
            <tr>
              <th class="text-left" colspan="2">Name</th>
              <th class="text-left">Email</th>
              <th class="text-left">Status</th>
              <th class="text-left">Role</th>
              <th class="text-center">Last Login</th>
              <th class="text-center">Signed Up Date</th>
              <th class="text-left" colspan="2">Organisation</th>
              <th class="text-center"></th>
            </tr>
            </thead>
            <tbody>
            <tr class="align-middle" *ngFor="let user of users">
              <td class="text-right align-middle pr-0">
                <img class="rounded-circle user-avatar" [src]="user.avatar">
              </td>
              <td class="text-left align-middle">
                {{ user.fullName }}
              </td>
              <td class="align-middle">{{ user.email }}</td>
              
              <td class="align-middle" *ngIf="user.email">
                <button class="btn btn-sm"
                        data-toggle="modal"
                        data-target="#editStatusModal"
                        [ngClass]="{ 'btn-secondary': user.suspended == 1, 'btn-primary': user.suspended == 0 }"
                        (click)="getUserStatus(user)">
                  <span *ngIf="user.suspended == 0">Active</span>
                  <span *ngIf="user.suspended == 1">Inactive</span>
                </button>
              </td>

              <td class="align-middle" *ngIf="!user.email">
                <button class="btn btn-sm btn-secondary">
                <span>Inactive</span>
                </button>
              </td>

              <td class="align-middle">{{ user.roleName }} <i class="fa fa-check-circle text-success" *ngIf="user.role == 'individual' &&  user.subscriptionId" ></i></td>
              <td class="align-middle text-center" *ngIf="user.lastLogin == 0">___</td>
              <td class="align-middle text-center" *ngIf="user.lastLogin > 0">{{ user.lastLogin * 1000 | date: 'h:mma dd LLL yyyy' : '+1200' }}</td>
              <td class="align-middle text-center" *ngIf="user.signedUp == 0">___</td>
              <td class="align-middle text-center" *ngIf="user.signedUp > 0">{{ user.signedUp * 1000 | date: 'h:mma dd LLL yyyy' : '+1200' }}</td>
              <td class="text-right align-middle pr-0">
                <img class="user-avatar" src="../../../../assets/images/icons/company.svg" *ngIf="user.organisationId > 0 && user.organisationType == 'company'">
                <img class="user-avatar" src="../../../../assets/images/icons/school.svg" *ngIf="user.organisationId > 0 && user.organisationType == 'school'">
              </td>
              <td class="text-left align-middle pl-md-3">
                {{ user.organisation }}
              </td>
              <td class="text-center align-middle">
                <button class="btn btn-sm btn-secondary" data-toggle="modal" data-target="#editUserModal" (click)="getUserAttributes(user)" *ngIf="user.email">
                  <i class="fa fa-pencil-square"></i> Edit
                </button>
              </td>
            </tr>
            <tr *ngIf="!loading && users?.length == 0">
              <td class="align-middle text-center" colspan="7">No Record Found</td>
            </tr>
            </tbody>
          </table>

        </div>
      </div>

      <!-- Pagination -->
      <nav *ngIf="users?.length > 0" >
        <ul class="pagination justify-content-center">
          <li
            class="page-item"
            [ngClass]="{'disabled': currentPage == 1}"
            (click)="paginate(currentPage - 1)"
          >
            <a class="page-link" tabindex="-1">Previous</a>
          </li>
          <li
            class="page-item"
            *ngFor="let link of pageLinks"
            [ngClass]="{'active': currentPage == link}"
            (click)="paginate(link)"
          >
            <a class="page-link">{{ link }} <span class="sr-only" *ngIf="currentPage == link">(current)</span></a>
          </li>
          <li
            class="page-item"
            [ngClass]="{'disabled': currentPage == lastPage}"
            (click)="paginate(currentPage + 1)"
          >
            <a class="page-link">Next</a>
          </li>
        </ul>
      </nav>
      <!-- End of Pagination -->
    </div>

    <!-- Modal Loader -->
    <modal-loader [modalText]="modalText"></modal-loader>

    <!-- Edit Status Modal -->
    <div class="modal fade" id="editStatusModal" role="dialog" aria-labelledby="editStatusModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold" id="editStatusModalLabel">Edit User Status</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <!-- Error Submit Message -->
          <div class="alert alert-danger alert-dismissible fade show" role="alert" *ngIf="submitError">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="submitError = !submitError">
              <span aria-hidden="true">&times;</span>
              <span class="sr-only">Close</span>
            </button>
            {{ submitErrorMsg }}
          </div>

          <div class="modal-body">
            <div class="md-input mb-2">
              <select
                id="selectUSerStatus"
                class="md-form-control"
                required
                [(ngModel)]="userStatus"
                (change)="changeStatus()"
              >
                <option *ngFor="let status of statusOptions" [value]=status.value>
                  {{ status.text }}
                </option>
              </select>
              <!--<span class="select-down-icon normal"><i class="fa fa-caret-down"></i></span>-->
              <span class="highlight"></span>
              <span class="bar"></span>
              <label>Status</label>
            </div>
            <div class="" [hidden]="!activePrompt">
              <label class="text-danger text-justify">Are you sure to make this user active? If so, the user will be asked to make a subscription when they login.</label>
            </div>
            <div class="" [hidden]="!inactivePrompt">
              <label class="text-danger text-justify">Are you sure to make this user inactive? If so, the subscription will be cancelled.</label>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" id="close-editStatusModal-modal" class="btn btn-secondary btn-modal-cancel" data-dismiss="modal">Cancel</button>
            <button type="submit" class="btn btn-primary btn-modal-save" (click)="updateUserStatus()" >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- End of Status Modal -->

    <!-- Edit Modal -->
    <div class="modal fade" id="editUserModal" role="dialog" aria-labelledby="editUserModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold" id="editUserModalLabel">Edit User Role</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <!-- Error Submit Message -->
          <div class="alert alert-danger alert-dismissible fade show" role="alert" *ngIf="submitError">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="submitError = !submitError">
              <span aria-hidden="true">&times;</span>
              <span class="sr-only">Close</span>
            </button>
            {{ submitErrorMsg }}
          </div>

          <div class="modal-body">
            <form [formGroup]="editUserForm" (ngSubmit)="updateUserRole()" id="ngForm">
              <div class="md-input">
                <select
                  class="md-form-control"
                  required
                  formControlName="userRole"
                  id="statusSelect"
                  (change)="showOrganisation()"
                  [ngClass]="{'error': (submitted && editUserForm.invalid && f.userRole.invalid) || (f.userRole.dirty && f.userRole.invalid)}"
                >
                  <option *ngFor="let role of roles" [value]="role.value">{{ role.text }}</option>
                </select>
                <span class="highlight"></span>
                <span class="bar"></span>
                <label>Role</label>
                <!--<span class="select-down-icon normal"><i class="fa fa-caret-down"></i></span>-->
              </div>
            </form>
            <div class="md-input d-none" id="organisationFormContainer">
              <select
                class="md-form-control"
                required
                [(ngModel)]="organisationId"
                id="organisationSelect">
                <option *ngFor="let org of organisations" [value]="org.id">{{ org.name }}</option>
              </select>
              <span class="highlight"></span>
              <span class="bar"></span>
              <label id="orgLabel">Organisation</label>
              <!--<span class="select-down-icon"><i class="fa fa-caret-down"></i></span>-->
            </div>

            <div class="" [hidden]="!individualPrompt">
              <label class="text-danger text-justify">The user will need to set up the subscription payment when he/she logins. Would you like to change the role?</label>
            </div>

            <div class="" [hidden]="!nonIndividualPrompt">
              <label class="text-danger text-justify">The user has a subscription. Would you like to cancel the subscription and change the role?</label>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" id="close-editUserModal-modal" class="btn btn-secondary btn-modal-cancel" data-dismiss="modal">Cancel</button>
            <button type="submit" class="btn btn-primary btn-modal-save" form="ngForm">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- End of Edit Modal -->

  </div>

</div>
